<template>
    <div id="subscription">
        <h2>{{$t('subscription.title')}}</h2> 
            <!-- If org has a valid subscription - show their current plan  -->
            <div id="current-plan" v-if="paymentSucces && !paymentFlowInProgress">
            <!-- <div id="current-plan" v-if="subscription && !changingSubscription"> -->
                <subscription-overview :subscription="subscription" @change-subscription="changingSubscription = !changingSubscription"/>
            </div>
            <!-- If no subscription / on a trial user - Show available plans  -->
            <div id="available-plans" v-else>
                <!-- if organization is a webshop - show the 4 standard plans -->
                <div id="e-commerce-plans">
                    <div class="header-info" :class="{'header-chosen-plan-step': chosenPlan && !paymentInfoStep, 'header-payment-step' : chosenPlan && paymentInfoStep}">
                        <div class="header-text" v-if="!paymentSucces">  
                            <button v-if="paymentInfoStep" @click="paymentInfoStep = false" class="btn">
                                <i class="fa-light fa-chevron-left"></i>
                                <span> {{$t('subscription.back-to-billing')}}</span>
                            </button> 
                            <button v-else-if="chosenPlan" @click="chosenPlan = null" class="btn">
                                <i class="fa-light fa-chevron-left"></i>
                                <span> {{$t('subscription.see-all-subscriptions')}}</span>
                            </button> 
                            <button v-else-if="changingSubscription" @click="changingSubscription = !changingSubscription" class="btn">
                                <i class="fa-light fa-chevron-left"></i>
                                <span>{{$t('subscription.choose-subscription')}}</span>
                            </button> 
                            <span v-else >{{$t('subscription.choose-subscription')}}</span>
                        </div>
                        <div class="header-actions">
                            <toggle-button
                                class="toggle"
                                v-if="!chosenPlan"
                                :text="toggleText"
                                :onToggleButton="togglePayment"
                                :value="showingAnnual"
                                :reverseLayout="true"
                            />
                                <!-- :value="comparisonView" -->
                            <dropdown class="currency-dropdown" v-if="!paymentInfoStep" left>
                                <span slot="toggle" style="width: 13px; cursor: pointer">
                                    <span>{{$t('subscription.currency')}}</span>
                                    <span class="currency">{{currentCurrency}}</span>
                                    <i class="fa-light fa-chevron-down"></i>
                                </span>
                                <div 
                                    class="dropdown-item"
                                    v-for="(currency, index) in availableCurrencies" 
                                    :key="index" 
                                    @click="currentCurrency = currency"
                                >
                                    {{currency}}
                                </div>
                            </dropdown>
                        </div>
                    </div>
                    
                    <div class="plans" v-if="!chosenPlan">
                        <div 
                        class="plan" 
                        v-for="(plan, index) in mergedPlanData"
                        :key="index"
                        >   
                            <!-- <subscription-plan :plan="plan" :currentCurrency="currentCurrency" :paymentFrequency="showingAnnual ? availablePaymentFrequencies[0] : availablePaymentFrequencies[1] " :planIsCurrent="changingSubscription && subscription.plan.name == plan.name"> -->
                            <subscription-plan :plan="plan" :currentCurrency="currentCurrency" :paymentFrequency="availablePaymentFrequencies[showingAnnual ? 0 : 1]" :planIsCurrent="changingSubscription && subscription.plan.name == plan.name">
                                <div slot="quote" class="quote">{{$t('subscription.what-you-get')}}</div>
                                <div slot="current" v-if="changingSubscription && subscription.plan.name == plan.name" class="current-plan" >{{$t('subscription.your-current-plan')}}</div>
                                <button slot="cta" v-else class="btn btn-primary" @click="standardPlanClicked(plan)">{{plan.name == 'Enterprise' ? $t('contact') : $t('subscription.cta')}}</button>
                            </subscription-plan>
                        </div>
                    </div>
                </div>                
                <!-- if organization is something other than webshop ???  -->
                <!-- <hub-spot-form/> -->
            </div>

        <div class="enterprise-subscription" v-if="chosenPlan && chosenPlan.name == 'Enterprise'">
            <hub-spot-form/>
        </div>
        <subscription-form
            v-if="chosenPlan && chosenPlan.name != 'Enterprise' && paymentFlowInProgress" 
            :plan="chosenPlan"
            :currentCurrency="currentCurrency"
            :organization="organization"
            :plans="plans"
            :paymentInfoStep="paymentInfoStep"
            :initialPaymentFrequency="availablePaymentFrequencies[showingAnnual ? 0 : 1]"
            @changed-plan="otherPlan => chosenPlan = otherPlan"
            @paymentStep="paymentInfoStep = true"
        />
        <div v-if="upgradeStep && chosenPlan && changingSubscription && !paymentFlowInProgress" class="upgrade-view plans">
            <subscription-plan class="plan" :plan="currentPlan" :currentCurrency="currentCurrency" :paymentFrequency="availablePaymentFrequencies[showingAnnual ? 0 : 1]"/>
            
            <i class="fa-light fa-chevron-right"></i>
            <subscription-plan class="plan" :plan="chosenPlan" :currentCurrency="currentCurrency" :paymentFrequency="availablePaymentFrequencies[showingAnnual ? 0 : 1]">
                <button slot="cta" class="btn btn-primary">{{$t('subscription.accept-upgrade')}}</button>
            </subscription-plan>
        </div>

        <div class="vat-notice" v-if="!chosenPlan && !subscription">
            <p> {{$t('subscription.VAT-notice')}}</p>
        </div>
    </div>
    
</template>

<script>
import ToggleButton from '@/components/ToggleButton'
import SubscriptionForm from "@/components/SubscriptionForm";
import SubscriptionPlan from "@/components/SubscriptionPlan";
import SubscriptionOverview from "@/components/SubscriptionOverview";
import HubSpotForm from "@/components/HubSpotForm";
import EventBus from '@/assets/js/eventBus.js'
export default {
name: 'Subscription',
  data() {
    return {
        changingSubscription: false,
        upgradeStep: true,
        paymentSucces: null,
        paymentFlowInProgress: null,
        mergedPlanData: [],
        chosenPlan: null,
        paymentInfoStep: false,
        curentPlan: null,
        toggleFrequency: 0,
        showingAnnual: false,
        toggleText: this.$t('subscription.toggle-text'),
        additionalPlanInfo: [
            {
                planName: "Small",
                ids: 1000,
                publications: 1,
                workshopHours: 0,
                supportDa: "Live support / Chat",
                supportEn: "Live support / Chat",
                onboardingDa: "Get started guide",
                onboardingEn: "Get started guide",
                descriptionDa: this.$t('subscription.plan-1-desc'),
                descriptionEn: this.$t('subscription.plan-1-desc')
            },
            {
                planName: "Medium",
                ids: 5000,
                publications: 1,
                workshopHours: 2,
                supportDa: "Live support / Chat",
                supportEn: "Live support / Chat",
                onboardingDa: "Get started guide",
                onboardingEn: "Get started guide",
                descriptionDa: this.$t('subscription.plan-2-desc'),
                descriptionEn: this.$t('subscription.plan-2-desc')
            },
            {
                planName: "Large",
                ids: 10000,
                publications: 1,
                workshopHours: 4,
                supportDa: "Live support / Chat",
                supportEn: "Live support / Chat",
                onboardingDa: "Get started guide",
                onboardingEn: "Get started guide",
                descriptionDa: this.$t('subscription.plan-3-desc'),
                descriptionEn: this.$t('subscription.plan-3-desc')
            },
            {
                planName: "Enterprise",
                ids: 10000,
                publications: this.$t('subscription.unlimited'),
                workshopHours: this.$t('subscription.unlimited'),
                supportDa: "Live support / Chat",
                supportEn: "Live support / Chat",
                onboardingDa: "Get started guide",
                onboardingEn: "Get started guide",
                descriptionDa: this.$t('subscription.plan-4-desc'),
                descriptionEn: this.$t('subscription.plan-4-desc')
            },

        ],
        subscription1: null,
        subscription:{    
            "uuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            "account_uuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            "account_code": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
            "terms": {
                "uuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                "code": "string",
                "interval_type": "month",
                "interval_count": 1,
                "price": 3999,
                "currency": "DKK",
                "backwards_charging": true,
                "active": true,
                "revenue_group": "string",
                "model": "string",
                "schema": "string"
            },
            "plan": {
                "uuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
                "name": "Large",
                "code": "string",
                "collect_vat": true,
                "vat_type": "physical",
                "model": "string",
                "schema": "string"
            },
            "status": "string",
            "current_mrr": "string",
            "committed_mrr": "string",
            "final_price": "string",
            "custom_fields": {
                "generation_limit": 5000,
                "integration_limit": 2,
                "plan_name": "Medium",
                "template_limit": 2,
                "users_limit": 5,
                "workshop_hours": 2
            },
            "model": "string",
            "schema": "string",
            "start_date": "2021-11-03T12:42:43.161Z",
            "end_date": "2021-11-03T12:42:43.161Z",
            "next_renewal_date": "2021-11-03T12:42:43.161Z",
            "last_renewal_date": "2021-11-03T12:42:43.161Z",
            "base_renewal_date": "2021-11-03T12:42:43.161Z",
            "quantity": 0,
            "collection_method": "invoice",
            "group_on_invoice": true,
            "payment_terms": 0,
            "override_price": "string",
            "pre_renewal_days_offset": 0,
            "reference_person": "Frederik Frost Jensen",
            "account_reference_person": "Frederik Frost Jensen",
            "po_number": "**** **** **** 4242",
            "case_number": "string",
            "invoice_supplement": "string",
            "created_date": "2021-11-03T12:42:43.161Z",
            "last_modified_date": "2021-11-03T12:42:43.161Z"

        },
        currentCurrency:'DKK',
        unavailablePlans: ["License" ,"Managed Services"],
        availablePlans: ["Small", "Medium", "Large", "Enterprise"]
    };
  },
  methods: {
    desiredPrice(price){
        let priceData = price.find(plan => plan.currency == this.currentCurrency && plan.interval_type == "month" ) 
        priceData.monthlyPriceForAnnual = parseInt(priceData.price) / 12
        return priceData
    },
    standardPlanClicked(plan){
        if(this.changingSubscription){
            console.log("The user is about to upgrade or downgrade")
            this.upgradeStep = true
            this.chosenPlan = Object.assign(plan, this.additionalPlanInfo.find(planInfo => planInfo.planName == plan.name))
            this.currentPlan = {...this.subscription.plan, ...this.subscription.terms}
            Object.assign(this.currentPlan, this.additionalPlanInfo.find(planInfo => planInfo.planName == this.currentPlan.name))
            
        }   
        else{
            this.paymentFlowInProgress = true
            // this.chosenPlan = plan
            this.chosenPlan = Object.assign(plan, this.additionalPlanInfo.find(planInfo => planInfo.planName == plan.name))
            // console.log(this.chosenPlan)
            // console.log(plan)
        }
    },
    togglePayment(){
        this.showingAnnual = !this.showingAnnual
        if(this.toggleFrequency == 0) this.toggleFrequency == 1
        if(this.toggleFrequency == 1) this.toggleFrequency == 0
    }
  },

  created(){
      this.plans.forEach(plan => {
        const planData = Object.assign(plan, this.additionalPlanInfo.find(planInfo => planInfo.planName == plan.name))
        this.mergedPlanData.push(planData)
    });
  },

  mounted(){
      EventBus.$on('end-payment-flow', () => {
          if(this.paymentFlowInProgress) this.paymentFlowInProgress = null
      });
      EventBus.$on('payment-success', () => {
          this.paymentSucces = true
      });
  },

  computed:{
      organization(){
          return this.$store.state.organization
      },
      availableCurrencies(){
          let currencies = []
          this.$store.state.subscriptionPlans.map(plan => {
              plan.planterms_set.forEach(term => {
                currencies.push(term.currency)
              })
          })
          return new Set(currencies)
      },
      availablePaymentFrequencies(){
        //   let frequencies = []
        //   this.$store.state.subscriptionPlans.map(plan => {
        //       plan.planterms_set.forEach(term => {
        //         frequencies.push(term.intervalType)
        //       })
        //   })
        //     frequencies = new Set(frequencies)
        //   return Array.from(frequencies)
        return ['year', 'month']
      },
      plans(){
        //   return this.$store.state.subscriptionPlans.filter(plan => !this.unavailablePlans.includes(plan.name)).reverse()
          return this.$store.state.subscriptionPlans.filter(plan => this.availablePlans.includes(plan.name)).reverse()
      }
  },
  components: {
      SubscriptionForm,
      SubscriptionPlan,
      SubscriptionOverview,
      HubSpotForm,
      ToggleButton
  }

};
</script>
<style lang="less">
#subscription{
  padding: 103px 40px 20px ;
  h2{
    padding-bottom: 45px;
  }
  .currency{
    margin-right: 4px;
  }
    #e-commerce-plans{
        .header-info{
            display: flex;
            justify-content: space-between;
            .header-text{
                opacity: .7;
                margin-top: 4px;
                .btn{
                    font-size: 14px;  
                    opacity: .7;
                    padding:0;
                    display: flex;
                    gap: 8px;
                    align-items: center;
                }
                img{
                    transform: rotate(180deg);
                }
            }
            .header-actions{
                display: flex;
                justify-content: flex-end;
                align-items: center;
                gap: 24px;
            }
        }
        .header-chosen-plan-step, .header-payment-step{
            display: grid;
            gap: 20px;
            grid-template-columns: minmax(300px, 500px) minmax(240px, 280px);
            justify-content: center;
        }
        .header-payment-step{
            // display: block;
            // margin: 0 auto;
            grid-template-columns: 500px;
            justify-content: center;
        }
        .currency-dropdown{
            justify-self: end;
        }
    }
    .plans{
        position: relative;
        margin-top: 24px;
        display: grid;
        grid-template-columns: repeat(auto-fit , minmax(240px ,1fr));
        grid-template-rows: auto;
        gap: 12px;
        .plan{
            border-radius: var(--standard-border-radius);
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.1);
            padding: 20px;
            background: #fff;
            min-height: 100px;
            display: flex;
            flex-direction: column;
            .btn{
                justify-self: end;
            }
        }
    }
    .upgrade-view{
        grid-template-columns: minmax(240px ,300px) auto  minmax(240px ,300px);
        gap: 40px;
        justify-content: center;
        svg{
            align-self: center;
        }
    }
    .vat-notice{
        margin-top: 12px;
        text-align: center;
        opacity: .7;
    }
}
</style>
